import { render, staticRenderFns } from "./OtherDamageType.vue?vue&type=template&id=20eb3986&scoped=true"
import script from "./OtherDamageType.vue?vue&type=script&lang=ts"
export * from "./OtherDamageType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eb3986",
  null
  
)

export default component.exports